<template>
  <div>
    <Modal :title="$t('global.are-you-sure-deactivate-2fa')" @close="close" @confirm="confirm">
      <template #footer>
        <Btn variant="light" class="mr-2" @click="close">
          {{ $t("global.cancel") }}
        </Btn>
        <Btn variant="danger" @click="confirm">
          {{ $t("global.deactivate") }}
        </Btn>
      </template>
    </Modal>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import Modal from "@/components/display/Modal";

export default {
  name: "ConfirmDisable2fa",
  components: {
    Btn,
    Modal,
  },
  setup(props, { emit }) {
    const close = () => {
      emit("close");
    };

    const confirm = () => {
      emit("confirm");
    };

    return {
      close,
      confirm,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
